<p-dialog header="Map Layers" [(visible)]="visible" [modal]="true" [closable]="false"
  [styleClass]="'custom-dialog'">
  <div class="map-layers-modal">
    <div class="field">
      <label for="map-type">Map Type</label>
      <div class="map-type-options">
        <div class="map-option" [class.selected]="selectedMapType === 'satellite'" (click)="selectMapType('satellite')">
          <img [src]="getMapboxPreviewURL('satellite')" alt="Satellite" />
          <p *ngIf="selectedMapType === 'satellite'">Satellite</p>
        </div>
        <div class="map-option" [class.selected]="selectedMapType === 'streets'" (click)="selectMapType('streets')">
          <img [src]="getMapboxPreviewURL('streets')" alt="Streets" />
          <p *ngIf="selectedMapType === 'streets'">Streets</p>
        </div>
        <div class="map-option" [class.selected]="selectedMapType === 'terrain'" (click)="selectMapType('terrain')">
          <img [src]="getMapboxPreviewURL('terrain')" alt="Terrain" />
          <p *ngIf="selectedMapType === 'terrain'">Terrain</p>
        </div>
      </div>
    </div>

    <div class="field">
      <p-inputSwitch [(ngModel)]="showEvacuationRadius"></p-inputSwitch>
      <span>Show Evacuation Radius</span>
    </div>

    <div class="field">
      <p-inputSwitch [(ngModel)]="showEventsOutsideView"></p-inputSwitch>
      <span>Show Events Outside View</span>
    </div>

    <div class="field">
      <app-checkbox [(ngModel)]="showPendingEvents" inputID="pendingEvents" label="Show Pending Events"></app-checkbox>
    </div>

    <div class="field">
      <app-checkbox [(ngModel)]="showCompletedEvents" inputID="completedEvents" label="Show Completed Events"></app-checkbox>
    </div>

    <!-- <div class="field">
      <p-inputSwitch [(ngModel)]="showSwimLanes"></p-inputSwitch>
      <span>Show Swim Lanes</span>
    </div> -->

    <div class="action-buttons">
      <button pButton label="Cancel" class="p-button-text p-button-secondary" (click)="onCancel()"></button>
      <button pButton label="Save" class="p-button-primary" (click)="onApply()"></button>
    </div>
  </div>
</p-dialog>
